import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

/**
 * Styles for ViewPanelLayout component
 */
export const useViewPanelLayoutStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    backgroundColor: theme.palette.background.default,
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  toolbar: {
    ...theme.mixins.toolbar,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.default,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    minHeight: 'auto !important',
  },
  main: {
    flexGrow: 1,
    '& main': {
      marginTop: 0,
    },
  },
}));
